import { z } from "zod"

const kyberRouteHopSchema = z
  .object({
    pool: z.string(),
    tokenIn: z.string(),
    tokenOut: z.string(),
    swapAmount: z.string(),
    amountOut: z.string(),
    exchange: z.string(),
    poolType: z.string(),
    poolExtra: z.unknown().optional(),
    extra: z.unknown().optional(),
  })
  .passthrough()

/**
 * Kyber routeSummary must be preserved exactly as returned by GET /routes
 * so it can be POSTed back to /route/build unchanged.
 */
export const kyberRouteSummarySchema = z
  .object({
    tokenIn: z.string(),
    amountIn: z.string(),
    amountInUsd: z.string().optional(),
    tokenOut: z.string(),
    amountOut: z.string(),
    amountOutUsd: z.string().optional(),
    gas: z.string().optional(),
    gasPrice: z.string().optional(),
    gasUsd: z.string().optional(),
    route: z.array(z.array(kyberRouteHopSchema)).optional(),
    routeID: z.string(),
    checksum: z.string().optional(),
    timestamp: z.union([z.string(), z.number()]).optional(),
  })
  .passthrough()

export const kyberRouteResponseSchema = z.object({
  code: z.number(),
  message: z.string().optional(),
  data: z.object({
    routeSummary: kyberRouteSummarySchema,
    routerAddress: z.string(),
  }),
  requestId: z.string().optional(),
})

export const kyberBuildResponseSchema = z.object({
  code: z.number(),
  message: z.string().optional(),
  data: z.object({
    amountIn: z.string(),
    amountInUsd: z.string().optional(),
    amountOut: z.string(),
    amountOutUsd: z.string().optional(),
    gas: z.string(),
    gasUsd: z.string().optional(),
    data: z.string(),
    routerAddress: z.string(),
    transactionValue: z.string().optional(),
  }),
  requestId: z.string().optional(),
})

export type KyberRouteResponse = z.infer<typeof kyberRouteResponseSchema>
export type KyberBuildResponse = z.infer<typeof kyberBuildResponseSchema>
export type KyberRouteSummary = z.infer<typeof kyberRouteSummarySchema>
